(function() {
$(document).ready(function() {

    var ocShopaholic = $('.oc-filter-shopaholic'),
        defaultInputValues = [];

    collectDefaultValue();

    /**
     * collect value for inputs in 'oc-filter-shopaholic' container and push the values in arr defaultInputValues ass obj with names of inputs as keys
     */
    function collectDefaultValue() {
        var filterInputsArr = $('.oc-filter-shopaholic').find('input[type="text"]');

        for ( var i = 0; i < filterInputsArr.length; i++ ) {
            var $currentInput = $(filterInputsArr[i]),
                inputName = $currentInput.attr('name'),
                inputObj = Object.create(Object.prototype);

            inputObj[inputName] = $currentInput.val();
            defaultInputValues.push(inputObj);
        }
    }

    function filterShopaholicFunction() {
        var _searchResult = '',
            _arSearch = location.search.split('&'),
            ocShopaholicWrap = ocShopaholic.find('.oc-filter-shopaholic-wrap');

        if(_arSearch[0][0] == '?') {
            _arSearch[0] = _arSearch[0].slice(1);
        }

        for(var i = 0; i < _arSearch.length; i++) {
            if(_arSearch[i].indexOf('filter') == -1 && _arSearch[i].indexOf('page') == -1 && _arSearch[i] !== '') {
                _searchResult += _arSearch[i] + '&';
            }
        }

        ocShopaholicWrap.each(function() {
            var _this = $(this),
                _thisWrapPropId = _this.attr('data-prop-id'),
                _thisWrapType = _this.attr('data-filter-type'),
                _searchString;

            switch(_thisWrapType) {
                case 'checkbox':
                    _searchString = '';
                    _this.find('input[type="checkbox"]').each(function() {
                        var _this = $(this);
                        if(_this.is(':checked')) {
                            _searchString += '|' + _this.val();
                        }
                    });
                    if(_searchString.length == 0) { return; }
                    _searchResult += 'filter[' + _thisWrapPropId + ']=' + _searchString.slice(1) + '&';
                    break;

                case 'switch':
                    _searchString = '';
                    var _thisValLength = 0;
                    _this.find('input[type="radio"]').each(function() {
                        var _this = $(this);
                        if(_this.is(':checked')) {
                            _thisValLength = _this.val().length;
                            _searchString += '|' + _this.val();
                        }
                    });
                    if(_thisValLength == 0) { return; }
                    _searchResult += 'filter[' + _thisWrapPropId + ']=' + _searchString.slice(1) + '&';
                    break;

                case 'select_between':
                    _searchString = '';
                    var bFirst = true;

                    _this.find('select').each(function() {
                        var _this = $(this);
                        if(_this.val().length > 0) {
                            if(!bFirst) {
                                _searchString += '|';
                            }

                            _searchString += _this.val();
                        }

                        bFirst = false;
                    });

                    if(_searchString.length == 0) { return; }
                    _searchResult += 'filter[' + _thisWrapPropId + ']=' + _searchString + '&';
                    break;

                case 'select':
                    _searchString = '';
                    _this.find('select').each(function() {
                        var _this = $(this);
                        if(_this.val().length > 0) {
                            _searchString = _this.val();
                        }
                    });
                    if(_searchString.length == 0) { return; }
                    _searchResult += 'filter[' + _thisWrapPropId + ']=' + _searchString + '&';
                    break;

                case 'input':
                    _searchString = '';
                    _this.find('input[type="text"]').each(function() {
                        var _this = $(this);
                        if(_this.val().length > 2) {
                            _searchString = _this.val();
                        }
                    });
                    if(_searchString.length == 0) { return; }
                    _searchResult += 'filter[' + _thisWrapPropId + ']=' + _searchString + '&';
                    break;

                case 'between':
                    _searchString = '';
                    var bFirst = true;

                    _this.find('input[type="text"]').each(function() {
                        var _this = $(this);
                        if(_this.val().length > 0) {
                            if(!bFirst) {
                                _searchString += '|';
                            }

                            _searchString += _this.val();
                        }

                        bFirst = false;
                    });

                    if(_searchString.length == 0) { return; }
                    _searchResult += 'filter[' + _thisWrapPropId + ']=' + _searchString + '&';
                    break;

            }
        });

        //if user browser is IE or EDGE encode sort string
        //var sortStr = document.documentMode || /Edge/.test(navigator.userAgent) ?  encodeURIComponent(_searchResult.slice(0, -1)) : _searchResult.slice(0, -1);
        //history.replaceState(null, null, location.origin + location.pathname + '?' + sortStr);

        history.replaceState(null, null, location.origin + location.pathname + '?' + _searchResult.slice(0, -1));

        //send ajax request
        if(typeof filterShopaholicAjaxRequest == 'function') {
            filterShopaholicAjaxRequest();
        }
    }

    ocShopaholic.on('change', '.oc-filter-shopaholic-wrap input[type="checkbox"]', function() {
        filterShopaholicFunction();
    });

    ocShopaholic.on('change', '.oc-filter-shopaholic-wrap input[type="radio"]', function() {
        filterShopaholicFunction();
    });

    ocShopaholic.on('change', '.oc-filter-shopaholic-wrap select', function() {
        filterShopaholicFunction();
    });

    ocShopaholic.on('blur', '.oc-filter-shopaholic-wrap input[type="text"]', function(e) {
        var $currentInput = $(e.target),
            currentValue = $currentInput.val();

        //find oldInput value of currentInput in the defaultInputValues
        for ( var i = 0; i < defaultInputValues.length; i++ ) {
            var inputName = $currentInput.attr('name');
            //find oldInputValue obj for current input
            if ( defaultInputValues[i].hasOwnProperty(inputName) ){
                var oldInputValue = defaultInputValues[i][inputName];

                //if current value different from oldValue do some logic
                if( currentValue != oldInputValue) {
                    //updateOldValue for current input
                    defaultInputValues[i][inputName] = currentValue;

                    filterShopaholicFunction();
                }
                break;
            }
        }
    });

    ocShopaholic.on('clearFilter', '.oc-filter-shopaholic-wrap input[type="text"]', function(e) {
        filterShopaholicFunction();
        collectDefaultValue();
    });

    window.filterShopaholicReset = function () {
        
        let _inputRadio = ocShopaholic.find('input[type="radio"]');

        ocShopaholic.find('input[type="checkbox"]').prop('checked', false);
        ocShopaholic.find('input[type="text"]').val('');

        for(var i = 0; i < _inputRadio.length; i++) {
            if($(_inputRadio[i]).val().trim() === '') {
                $(_inputRadio[i]).prop('checked', true);
            }
        }

        ocShopaholic.find('select').val('');
        filterShopaholicFunction();
    };
});
})(jQuery);


// WEBPACK FOOTER //
// ./plugins/lovata/filtershopaholic/assets/js/main.js